import React, { useEffect, useRef } from "react";
import "../../../../src/App.css";
import ReactGoogleAutocomplete from "react-google-autocomplete";
import { FaLocationDot } from "react-icons/fa6";

const LocationSearch = ({ value, disabled, onSelect, placeholder }) => {
  const inputRef = useRef(null);

  return (
    <div
      className={
        window.location.pathname === "/CreateAthleteProfile"
          ? "input-group-accountInfo-create-profile"
          : "input-section-accountInfo"
      }
    >
      <div
        className={
          window.location.pathname === "/CreateAthleteProfile"
            ? "input-group-accountInfo-create-profile"
            : "input-group-accountInfo"
        }
      >
        <div className="input-icon-accountInfo">
          <FaLocationDot />
        </div>
        <ReactGoogleAutocomplete
          ref={inputRef}
          apiKey="AIzaSyAIbXDUuhft8Jo1uYi3dMt9HGxJ1OmGO_s"
          className={
            disabled
              ? "form-control-accountInfo-disable"
              : "form-control-accountInfo"
          }
          placeholder={placeholder}
          disabled={disabled}
          value={value}
          onChange={(e) => {
            onSelect(e.target.value);
          }}
          onPlaceSelected={(place) => {
            const selected = place?.formatted_address || place?.name || "";

            onSelect(selected);
          }}
        />
      </div>
    </div>
  );
};

export default LocationSearch;
